//VERSION ESTABLE
import React, { useState } from 'react';
import { CgViewComfortable } from 'react-icons/cg';
import { useDispatch, useSelector } from 'react-redux';
import { addGroupToApi } from '../../store/grupo.actions'; // Asegúrate de tener esta acción en tu archivo de acciones
import '../../assets/styles/menu-grupomodal.css';



export function AddGroupModal() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [nombreGrupo, setNombreGrupo] = useState('');
    const currentBoard = useSelector((storeState) => storeState.boardModule.currentBoard);
    const [color, setColor] = useState('#ffffff'); // Inicializa con un color por defecto
    // const dispatch = useDispatch();

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const onSubmit = async (ev) => {
        ev.preventDefault();
        const newGroup = {
            nombre_grupo: nombreGrupo,
            estado: 1,
            fk_tableros_id: currentBoard.id_tablero, // Convierte a string si es necesario
            color: color || '#2149D4' // Usa color por defecto si no hay color seleccionado
        };
        try {
            (addGroupToApi(newGroup));
            closeModal();
        } catch (err) {
            console.error('Failed to add group:', err);
        }
    };

    return (
        <div className='add-group-modal'>
            <div className='add-group' onClick={openModal}>
                <CgViewComfortable className='icon' />
                <span>Nuevo Grupo</span>
            </div>
            {isModalOpen && (
                <div className="modal-overlay" onClick={closeModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <form onSubmit={onSubmit}>
                            <h3>Agregar Grupo</h3>
                            <div>
                                <label>Grupo:</label>
                                <input
                                    type="text"
                                    value={nombreGrupo}
                                    onChange={(e) => setNombreGrupo(e.target.value)}
                                    required
                                />
                            </div>
                            <div>
                                <label>Tablero: </label>
                                <input
                                    type="text"
                                    value={currentBoard.nombre_tablero}
                                    readOnly // Campo de solo lectura
                                    required
                                />
                            </div>
                            <div>
                                <label>Color: </label>
                                <input
                                    type="color" // Cambiado a input de tipo color
                                    value={color}
                                    onChange={(e) => setColor(e.target.value)}
                                    required
                                />
                            </div>
                            <button type="submit">Añadir Grupo</button>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}


